import { AccessTime, CalendarToday } from "@mui/icons-material";
import { DateTimePicker } from "@mui/x-date-pickers";
import { useField, useFormikContext } from "formik";
import { StyledDateTimePicker } from "../../styled/FormikDatePicker";

const FormikDateTimePicker = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  const handleChange = (value) => {
    setFieldValue(props.name, value);
    if (props.callBack) {
      props.callBack(value);
    }
  };

  return (
    <DateTimePicker
      ampm={false}
      format="dd/MM/yyyy HH:mm"
      autoOk={true}
      timeIcon={<StyledDateTimePicker.Icon component={AccessTime} />}
      dateRangeIcon={<StyledDateTimePicker.Icon component={CalendarToday} />}
      {...props}
      {...field}
      error={meta.touched && meta.error ? true : false}
      helperText={meta.touched && meta.error ? meta.error : null}
      onChange={handleChange}
      slotProps={{
        textField: {
          variant: "standard",
          fullWidth: props.fullWidth || false,
          helperText: meta.touched && meta.error ? meta.error : null,
          error: meta.touched && meta.error ? true : false,
        }
      }}
    />
  );
};

export default FormikDateTimePicker;
